var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSw1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.32 10.6685C36.3033 11.3585 35.7317 11.9052 35.0417 11.8902C34.3517 11.8735 33.805 11.3018 33.82 10.6118L33.8883 7.60184L30.88 7.5335C30.19 7.51684 29.6433 6.94517 29.6583 6.25517C29.675 5.56517 30.2467 5.0185 30.9367 5.0335L35.1967 5.13184C35.8867 5.14684 36.4333 5.7185 36.4167 6.4085L36.32 10.6685Z",
    fill: "#FE7320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71166 15.5767V35.8117C9.71166 36.975 8.77 37.9167 7.60666 37.9167H4.18833C3.02499 37.9167 2.08333 36.975 2.08333 35.8117V15.5767C2.08333 14.415 3.02499 13.4717 4.18833 13.4717H7.60666C8.77 13.4717 9.71166 14.415 9.71166 15.5767Z",
    fill: "#FE7320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.515 25.8335V35.8118C28.515 36.3702 28.2933 36.9052 27.8983 37.3002C27.5033 37.6952 26.9683 37.9168 26.41 37.9168H22.9917C22.4333 37.9168 21.8983 37.6952 21.5033 37.3002C21.1083 36.9052 20.8867 36.3702 20.8867 35.8118V25.8335C20.8867 25.2752 21.1083 24.7402 21.5033 24.3452C21.8983 23.9502 22.4333 23.7285 22.9917 23.7285H26.41C26.9683 23.7285 27.5033 23.9502 27.8983 24.3452C28.2933 24.7402 28.515 25.2752 28.515 25.8335Z",
    fill: "#FE7320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1133 20.7051V35.8118C19.1133 36.9751 18.1717 37.9168 17.0083 37.9168H13.59C12.4267 37.9168 11.485 36.9751 11.485 35.8118V20.7051C11.485 20.1468 11.7067 19.6118 12.1017 19.2168C12.4967 18.8218 13.0317 18.6001 13.59 18.6001H17.0083C18.1717 18.6001 19.1133 19.5434 19.1133 20.7051Z",
    fill: "#FE7320"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9167 20.7051V35.8118C37.9167 36.9751 36.975 37.9168 35.8117 37.9168H32.3933C31.23 37.9168 30.2883 36.9751 30.2883 35.8118V20.7051C30.2883 20.1468 30.51 19.6118 30.905 19.2168C31.3 18.8218 31.835 18.6001 32.3933 18.6001H35.8117C36.975 18.6001 37.9167 19.5434 37.9167 20.7051Z",
    fill: "#FE7320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08333 4.3335C3.53 3.92016 3.41833 3.13516 3.83333 2.5835C4.24666 2.03183 5.03 1.92016 5.58333 2.3335L15.505 9.77516H20.2167C20.6017 9.77516 20.9633 9.95183 21.2 10.2535L25.0117 15.1052L33.845 5.88683C34.3217 5.3885 35.1133 5.37183 35.6117 5.85016C36.11 6.32683 36.1267 7.1185 35.65 7.61683L25.82 17.8735C25.57 18.1352 25.2183 18.2752 24.8567 18.2568C24.495 18.2402 24.1583 18.0652 23.935 17.7802L19.61 12.2752H15.0883C14.8183 12.2752 14.555 12.1885 14.3383 12.0252L4.08333 4.3335Z",
    fill: "#FE7320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw1);
export default __webpack_public_path__ + "static/media/sw1.36abbee6f1b81cbd8ed795f614913d75.svg";
export { ForwardRef as ReactComponent };